<template>
    <div v-show="errors.length>0" class="warning-comment">
      <h4>Внимение!</h4>
      <div>
        <ul class="item-list" v-for="error in errors" >
          <li>
            {{ error.msg }}
            <div v-if="error.msg.includes('Менеджер') && !checked" class="confirm-manager">
              <input type="checkbox" v-model="checked" @click="confirmManager"> Мною сверено, компания связанная
            </div>
          </li>
        </ul>
      </div>
   
    </div>
  </template>
  
  <script>
  import { ref,computed } from 'vue';

  export default {
    name: 'ExecutorWarning',
    props: ['errors'],
    setup(_,{emit}) {
      const checked = ref(false)
      const confirmManager = () => {
        emit('confirm',!checked.value)
      }

      return {
        checked,
        confirmManager,
      };
    },
  };
  </script>
  
  <style scoped>
  .warning-comment{
    color: red;
    font-size: 14px;
    max-width: 400px;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
  }
  .item-list{
    text-align: start;
  }

  .confirm-manager{
    margin-bottom: 10px;
    color: #000;
  }
  </style>
  